import { Button, Form } from 'antd';
import type { FormInstance } from 'rc-field-form';

import type { BulkEditFormValues } from 'app/typings/bulkEdit';

import type { FieldsDisplayValues } from '../BulkEdit';

type BulkEditFooterProps = {
  handleClose: () => void;
  openValues: FieldsDisplayValues;
  form: FormInstance<BulkEditFormValues>;
  isLoading: boolean;
};

export const BulkEditFooter = ({
  handleClose,
  openValues,
  form,
  isLoading,
}: BulkEditFooterProps) => {
  const allFieldsDisabled =
    !openValues.bar &&
    !openValues.stock &&
    openValues.packageDisplayValues.every(
      (value) => !value.discountPrice && !value.discountRate
    );

  return (
    <div className="bulkEdit__footer">
      <Form.Item shouldUpdate>
        {() => (
          <>
            <Button
              size="large"
              type="ghost"
              onClick={handleClose}
              key={'back'}
            >
              Cancel
            </Button>
            <Button
              key="save"
              size="large"
              type="primary"
              htmlType="submit"
              disabled={
                allFieldsDisabled ||
                !form.isFieldsTouched(['startDate', 'endDate'], true) ||
                !!form.getFieldsError().filter(({ errors }) => errors.length)
                  .length
              }
              loading={isLoading}
            >
              Save changes
            </Button>
          </>
        )}
      </Form.Item>
    </div>
  );
};
